import styled from 'styled-components';

export const Avatar = styled.img`
  border-radius: 100%;
  height: 28%;
  left: 36%;
  object-fit: cover;
  position: absolute;
  top: 36%;
  user-drag: none;
  width: 28%;
  z-index: 5;
`;
Avatar.displayName = 'Avatar';
